import React, { useEffect, useMemo, useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { Footer } from "../../components/Footer";
import { Navbar } from "../../components/Navbar";
import ReactMarkdown from "react-markdown";

import termsESUrl from "./privacyES.md";
import { useConfig } from "../../contexts/config";

function Privacy() {
  const { lang } = useAuth();
  const { config } = useConfig();

  const [md, setMd] = useState("");
  const [isInConfig, setIsInConfig] = useState(false);

  useEffect(() => {
    if (!config) return;

    if (config.politica_de_privacidad.privacy_policy && lang === "en") {
      setIsInConfig(true);
      setMd(config.politica_de_privacidad.privacy_policy);
      return;
    }

    if (config.politica_de_privacidad.privacy_policy_es && lang === "es") {
      setIsInConfig(true);
      setMd(config.politica_de_privacidad.privacy_policy_es);
      return;
    }

    // Por ahora cargamos el ES. Si luego agregas EN, lo seleccionamos por lang.
    fetch(termsESUrl)
      .then((r) => r.text())
      .then(setMd)
      .catch(() => setMd("No se pudieron cargar los términos y condiciones."));
  }, []);

  return (
    <>
      <Navbar />

      <div
        className="mx-auto font-poppins **:text-[14px] [&_a]:text-[14px] **:m-0 [&_a]:m-0 **:text-[#333333] [&_a]:text-[#333333] [&_ul]:ml-8 [&_ul]:list-disc"
        style={{ maxWidth: 900, padding: "100px 16px" }}
      >
        {isInConfig ? (
          <div dangerouslySetInnerHTML={{ __html: md }}></div>
        ) : (
          <ReactMarkdown>{md}</ReactMarkdown>
        )}
      </div>
      <Footer />
    </>
  );
}

export default Privacy;
